import React, { Component, Fragment } from 'react';
import { Modal } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { DropDownListComponent } from '@syncfusion/ej2-react-dropdowns';
import { connect } from 'react-redux';
import 'react-perfect-scrollbar/dist/css/styles.css';
import i18n from 'i18next';
import { Popover, PopoverBody } from 'reactstrap';

import { removeState } from '../../services/state';
import {
  resetDefaultAccount,
  addOrUpdateAccount
} from '../../services/accounts';
import { setConfigCalendar, setSign, lexonCredentialsClear } from '../../actions/lexon';
import {
  clearUserCredentials,
  setShowUserSignPopover,
  setShowDefaultCalendarPopover,
  setShowUserTemplatePopover
} from '../../actions/application';
import { setCurrentUser, currentUserCredentialsClear } from '../../actions/user';
import { resolveCalendarProvider } from '../../utils/configCalendar';
import AccountSign from './account-sign/account-sign';
import AccountTemplate from './account-template/account-template';
import '../main-bar/top-bar-message-list.scss';
import './menu-user.scss';

class MenuUser extends Component {
  constructor(props) {
    super(props);

    this.state = {
      dropdownOpen: false,
      disconnect: true,
      loading: false,
      defaultChange: false,
      showAccountOptions: false,
      provider: ''
    };

    this.wrapperRef = null;
    this.buttonRef = null;
    this.listObj = null;
    this.fields = { text: 'account', value: 'account' };
    this.blockRender = false;
    this._handleOnClick = this._handleOnClick.bind(this);
    this.onSaveSign = this.onSaveSign.bind(this);
    this.onSignChange = this.onSignChange.bind(this);
    this.itemTemplate = this.itemTemplate.bind(this);
  }

  componentDidMount() {
    const url = window.location.href;
    if (!url.includes('calendar')) {
      this.setState({ defaultChange: true });
    }
  }

  shouldComponentUpdate() {
    if (this.blockRender) {
      return false;
    }
    return true;
  }

  _handleOnClick() {
    this.routeLogout();
  }

  onSignChange(content) {
    this.props.handleSignChange(content);
  }

  async onSaveSign() {
    const { lexon, sign, accounts } = this.props;
    const accountToUpdate = accounts.find(
      acc => acc.provider === 'IMAP' && acc.email === lexon.account
    );
    const newAccount = {
      ...accountToUpdate,
      sign
    };

    this.props.setSign(sign);
    await addOrUpdateAccount(lexon.userId, newAccount, lexon.lexonToken);
    this.props.setShowUserSignPopover(false);
  }

  async onDefaultCalendarChange(args) {
    this.setState({ provider: args.itemData.provider });
    this.props.handleDefaultCalendarChange(args.itemData.account);
    this.listObj.refresh();
  }

  itemTemplate(data) {
    return (
      <div id={`calendarElement_${data.provider}_${data.account}`}>
        <img
          className="provImg"
          src={this.getImage(data.provider)}
          alt="provider"
          height="15px"
          width="16px"
        />
        <span className="account" style={{ paddingLeft: '10px' }}>
          {data.account}
        </span>
      </div>
    );
  }

  getImage(provider) {
    switch (provider) {
      case 'GOOGLE':
        return '/assets/images/google.svg';
      case 'OUTLOOK':
        return '/assets/images/microsoft.svg';

      default:
        return '/assets/images/imap.svg';
    }
  }

  routeLogout() {
    const { userId, token, lexonToken } = this.props.lexon;
    if (userId !== null) {
      resetDefaultAccount(userId, lexonToken)
        .then(() => {
          removeState();
        })
        .then(() => {
          //Call action to reset all redux info
          this.props.logout();
          const urlRedirect = token
            ? `${window.URL_SELECT_ACCOUNT}/access/${token}/`
            : `${window.URL_SELECT_ACCOUNT}/user/${userId}/encrypt/0`;
          window.location.replace(urlRedirect);
        });
    } else {
      removeState();
      window.location.reload();
    }
  }

  render() {
    const { dropdownOpen, showAccountOptions, provider } = this.state;
    const {
      showUserSignPopover,
      showDefaultCalendarPopover,
      defaultCalendar,
      accounts,
      lexon,
      login,
      currentUser,
      showUserTemplatePopover,
      encodeUrl
    } = this.props;
    const email = login?.formValues?.user;
    const fullName = currentUser?.name;
    const accCalendarList = accounts
      .filter(
        acc =>
          (acc.provider === 'IMAP' && acc.defaultAccount === true) ||
          acc.provider !== 'IMAP'
      )
      .map(acc => ({ provider: acc.provider, account: acc.email }));
    return (
      <Fragment>
        <div
          className={'menu-user'}
          id="menu-user-popover"
          onClick={() => {
            this.setState({
              dropdownOpen: !dropdownOpen
            });
          }}
        >
          <img
            className=""
            border="0"
            alt="avatar"
            src="/assets/icons/header/user.svg"
          />
          <div>
            <div className={`ml-2 avatar-full-name`}>
              {fullName}
            </div>
            <div className={`ml-2 avatar-email`}>
              {email}
            </div>
          </div>
        </div>
        <Popover
          trigger="legacy"
          isOpen={dropdownOpen}
          target="menu-user-popover"
          toggle={() => {
            if (!showAccountOptions) {
              this.setState({ dropdownOpen: false });
            }
          }}
          placement="bottom"
          className={'popover-menu-user'}
        >
          <PopoverBody>
            <div
              className={`pl-2 pt-3 menu-user-popover-container`}
            >
              <div className="menu-user-popover-text-ellipsis" title={fullName}>
                <span className={'menu-full-name'}>{fullName}</span>
              </div>
              <div className="menu-user-popover-text-ellipsis" title={email}>
                <span className={'menu-email'}>{email}</span>
              </div>
              <div className={`menu-use-divider my-3`} />
              <div
                id="my-account-option-popover"
                className={`d-flex align-items-center my-account-container`}
                onClick={() => {
                  window.open(`${window.MY_ACCOUNT_URL}${encodeUrl}`, '_blank');
                  this.setState({ showAccountOptions: !showAccountOptions });
                }}
              >
                <span
                  className={`lf-icon lf-icon-user mr-2`}
                />
                <span className={'popover-my-account'}>
                  {i18n.t('menu-user.my-account')}
                </span>
              </div>
              <div
                className={`d-flex align-items-center close-session-container my-1`}
                onClick={() => this.routeLogout()}
              >
                <span
                  className={`lf-icon lf-icon-close-session mr-2`}
                />
                <span className={'popover-close-session'}>
                  {i18n.t('menu-user.close-session')}
                </span>
              </div>
            </div>
          </PopoverBody>
        </Popover>
        <AccountSign
          showUserSignPopover={showUserSignPopover}
          setShowUserSignPopover={this.props.setShowUserSignPopover}
          accounts={accounts}
          account={this.props.lexon.account}
          loadUser={this.props.loadUser}
        />
        <AccountTemplate
          showUserTemplatePopover={showUserTemplatePopover}
          setShowUserTemplatePopover={this.props.setShowUserTemplatePopover}
          accounts={accounts}
          account={this.props.lexon.account}
          loadUser={this.props.loadUser}
        />
        <Modal
          show={showDefaultCalendarPopover}
          onHide={() => {
            this.props.setShowDefaultCalendarPopover(false);
          }}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          className="default-calendar-modal"
        >
          <Modal.Header>
            <div className="default-calendar-modal-header">
              <Modal.Title>{i18n.t('menu-user.default-calendar')}</Modal.Title>
            </div>
          </Modal.Header>
          <Modal.Body>
            <div id="defaultCalendar" className="form-group">
              <div className="mb-3 mt-4">
                <label className="inter-regular-16 text-color-grey-800">
                  {i18n.t('menu-user.default-calendar')}
                </label>
                <DropDownListComponent
                  id="defaultCalendarSelector"
                  dataSource={accCalendarList}
                  ref={dropdownlist => {
                    this.listObj = dropdownlist;
                  }}
                  fields={this.fields}
                  change={this.onDefaultCalendarChange.bind(this)}
                  placeholder={i18n.t('general.select_option')}
                  value={defaultCalendar}
                  popupHeight="220px"
                  itemTemplate={this.itemTemplate}
                />
                <span className="input-divider" />
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <div className="d-flex justify-content-end modal-btn-container">
              <button
                type="button"
                className="mr-left font-weight-bold btn-outline-primary btn btn-secondary"
                onClick={() => this.props.setShowDefaultCalendarPopover(false)}
              >
                {i18n.t('general.cancel')}
              </button>
              <button
                type="button"
                className="mr-left font-weight-bold btn-primary btn"
                onClick={async () => {
                  const { account, userId, lexonToken } = lexon;
                  const calendarProvider = resolveCalendarProvider(provider, accCalendarList, defaultCalendar);
                  if (!calendarProvider) {
                    return;
                  }
                  const accountToUpdate = accounts.find(
                    acc => acc.provider === 'IMAP' && acc.email === account
                  );
                  accountToUpdate.configCalendar = {
                    provider: calendarProvider,
                    account: defaultCalendar
                  };
                  await addOrUpdateAccount(userId, accountToUpdate, lexonToken);
                  this.props.setConfigCalendar(accountToUpdate.configCalendar);
                  this.props.setShowDefaultCalendarPopover(false);
                }}
              >
                {i18n.t('general.save')}
              </button>
            </div>
          </Modal.Footer>
        </Modal>
        <style>
          {`
            .progress-wrapper {
              display: flex;
              justify-content: center;
              height: 300px;
              align-items: center;
            }

            header h1 {
              color: black;
            }

            .buttons-footer {
              position: absolute;
              bottom: 10px;
              right: 10px;
            }

            .buttons-footer button {
              margin-right: 15px;
            }

            .buttons-footer button:hover {
              margin-right: 15px;
            }

            .menu-user {
              cursor: pointer;
            }

            .add-more-accounts > span {
              color: #001978 !important;
            }

            .menu-container {
              box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2),
                0 6px 20px 0 rgba(0, 0, 0, 0.19);
              border: 1px solid #cdd1e0;
              border-radius: 0;
              color: #001978;
            }

            .show-sign.menu-container {
              width: 800px;
              height: 446px;
            }

            .dropdown-menu-arrow {
              /* display: inline; */
              top: 5px;
              right: 13px;
              position: absolute;
              left: auto;
              width: 24px;
              height: 24px;
            }

            .mu-subheader {
              font-family: Inter, Lato, Arial, sans-serif;
              cursor: default;
              text-align: left !important;
              color: #333333 !important;
              font-size: 14px;
            }

            .dropdown-menu-arrow:before {
              bottom: -13px;
              right: -8px;
              border-bottom-color: rgba(0, 0, 0, 0.15);
            }

            .dropdown-menu-arrow:after {
              bottom: -13px;
              right: -8px;
              border-bottom-color: #fff;
            }

            .accounts-container {
              text-align: center;
            }

            .user-image-and-name {
              padding: 24px;
              margin-top: -29px;
            }

            .lf-icon-add-round {
              color: #001978;
            }

            .content .header {
              background-color: white;
              text-align: right;
              border: none;
              display: block;
              padding-left: 24px;
              padding-right: 24px;
              font-size: 0.875rem;
              color: #6c757d;
              white-space: nowrap;
            }

            .content .header > span {
              color: #001978;
              font-size: 13px;
              cursor: pointer;
            }

            .user-image-and-name .scrollbar-container {
              width: 100%;
            }

            .menu-container {
              position: absolute;
              background-color: white;
              top: 40px;
              right: -30px;
              width: 385px;
              z-index: 110;
              cursor: default;
            }

            .menu-title {
              font-size: 18px;
              font-weight: 500;
              border-bottom: 1px solid;
              padding-bottom: 5px;
              text-align: left;
              color: #001978;
            }

            .menu-title .mb-5 {
              text-decoration: none;
              color: #001978 !important;
            }

            .add-sign {
              display: flex;
              align-items: center;
              font-size: 16px;
              font-family: Inter, Lato, Arial, sans-serif;
              font-weight: 700;
              justify-content: center;
              color: #001978;
              cursor: pointer;
              margin-bottom: 10px;
            }

            .add-sign p {
              text-decoration: underline;
              padding: 0;
              margin: 0;
              margin-left: 5px;
            }

            .default-calendar {
              display: flex;
              align-items: center;
              font-size: 16px;
              font-family: Inter, Lato, Arial, sans-serif;
              font-weight: 700;
              justify-content: center;
              color: #001978;
              cursor: pointer;
              margin-top: 10px;
              margin-bottom: 10px;
            }

            .default-calendar p {
              padding: 0;
              margin: 0;
              margin-left: 5px;
            }

            .add-sign .lf-icon-feather {
              font-size: 20px;
              color: #001978;
            }

            .e-content.e-lib.e-keyboard {
              text-align: left;
            }
          `}
        </style>
      </Fragment>
    );
  }
}

MenuUser.propTypes = {
  fullName: PropTypes.string.isRequired
};

const mapStateToProps = state => ({
  lexon: state.lexon,
  login: state.login,
  currentUser: state.currentUser,
  showUserSignPopover: state.application.showUserSignPopover,
  showUserTemplatePopover: state.application.showUserTemplatePopover,
  showDefaultCalendarPopover: state.application.showDefaultCalendarPopover
});

const mapDispatchToProps = dispatch => ({
  logout: () => {
    dispatch(clearUserCredentials());
    dispatch(lexonCredentialsClear());
    dispatch(currentUserCredentialsClear());
  },
  setSign: sign => {
    dispatch(setSign(sign));
  },
  setCurrentUser: user => {
    dispatch(setCurrentUser(user));
  },
  setConfigCalendar: config => dispatch(setConfigCalendar(config)),
  setShowUserSignPopover: showUserSignPopover =>
    dispatch(setShowUserSignPopover(showUserSignPopover)),
  setShowUserTemplatePopover: showUserTemplatePopover =>
    dispatch(setShowUserTemplatePopover(showUserTemplatePopover)),
  setShowDefaultCalendarPopover: showDefaultCalendarPopover =>
    dispatch(setShowDefaultCalendarPopover(showDefaultCalendarPopover))
});

export default connect(mapStateToProps, mapDispatchToProps)(MenuUser);
